export const preparationConfig = [
  {
    link: 'preparation',
    icon: 'prepare',
    uuid: 'PREPARATION',
    tip: {
      chinese: '备课资源',
      english: 'content',
    },
  },
];
